import React, {useState, useRef, forwardRef, useImperativeHandle} from 'react';
import './index.scss';
import etsyPic from '../../../../assets/etsy.jpg';
import Form, {Item, RequiredRule, ButtonItem} from 'devextreme-react/form';
import storesApi from '../../../../api/stores';
import sessions from '../../../../sessions';

const Etsy = forwardRef((props, ref) => {
    const formData = useRef({});
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    const onSubmit = (async(e) => {
        if(e)e.preventDefault();

        const {shopName} = formData.current;
        if(shopName){
            try {
                await storesApi.getOauth("etsy", userId, shopName,auth).then(res => {
                    window.location.href = res.data.data
                })
            } catch (err) {
                console.log(err);
            }
        }
    })

    useImperativeHandle(ref, (e) => ({onSubmit}));

    return (
        <React.Fragment>
             <div className="bridge-header">
                <img alt="etsyPic" src={etsyPic} className="logo-size"/>
            </div>
            <div className="bridge-content">
                <div className="bridge-content">
                    <form onSubmit={onSubmit}>
                        <Form formData={formData.current} className="form-field" labelLocation={'left'}>
                            <Item
                                dataField="shopName"
                                editorType="dxTextBox"
                                showClearButton={true}
                                editorOptions={{
                                width:200,
                                stylingMode: 'filled',
                                placeholder: ''
                            }}>
                                <RequiredRule message="shopname is required"/>
                            </Item>
                            <ButtonItem horizontalAlignment="left"
                            //This button help to preventdefault
                            buttonOptions={{
                                text: 'shadowButton',
                                type: 'success',
                                useSubmitBehavior: true,
                                visible:false
                            }}
                            />
                        </Form>
                    </form>
                    <br/>
                </div>
            </div>
            <div className={'bridge-footer'}>
                <p className={'etsy-disclaimer'}>The term 'Etsy' is a trademark of Etsy, Inc. This application uses the Etsy
                    API, but is not endorsed or certified by Etsy, Inc.</p>
            </div>
        </React.Fragment>
    );
})

export default Etsy;